<script>
  import ClientList from '../../components/clients/ClientList.svelte'
</script>

<div class="notifications">
  <div class="columns">
    <div class="column">
      <div class="content">
        <ClientList />
      </div>
    </div>
  </div>
</div>
